import { render, staticRenderFns } from "./FmsDashboard.vue?vue&type=template&id=2c28fba4&scoped=true"
import script from "./FmsDashboard.vue?vue&type=script&lang=js"
export * from "./FmsDashboard.vue?vue&type=script&lang=js"
import style0 from "./FmsDashboard.vue?vue&type=style&index=0&id=2c28fba4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c28fba4",
  null
  
)

export default component.exports